module.exports = __webpack_public_path__ + "main/assets/public/on-today/down-arrow.b4df2929237ad8f2.svg";